import { getIn, useFormikContext } from "formik"
import { AvailableVehiclesFieldFormik } from "./fields/AvailableVehiclesFieldFormik";
import { RegisterRow } from "./fields/RegisterRow";
import { DepositInstallmentsFormik } from "./fields/DepositInstallmentsFormik";
import { AvailablePeriodsFieldFormik } from "./fields/AvailablePeriodsFieldFormik";

function FormActivateRenterMotoClub() {
  const formik = useFormikContext()
  const vehicle = getIn(formik.values, 'vehicle')
  const registers = getIn(formik.values, 'registers')

  return (
    <div className="grid grid-cols-1">
      <AvailableVehiclesFieldFormik partnerId={""} companyId={""} />
      <AvailablePeriodsFieldFormik />
      <DepositInstallmentsFormik />
      <div className="grid gap-2">
        <h2 className="text-2xl font-semibold mb-4">Registros do veículo</h2>
        {(!vehicle || !vehicle._id) && <small className="text-redPrimary">Selecione um veículo para adicionar as fotos</small>}

        {registers?.map((doc, index) => (
          <div key={index} className={`space-x-3 px-3 py-2 my-0 rounded ${index % 2 ? 'bg-gray/5' : 'bg-gray/25'}`}>
            <RegisterRow
              initialData={doc || {}}
              name={`registers.${index}`}
              onRemoveClick={() => formik.setFieldValue('registers', registers.filter((_, i) => i !== index))}
              prefix="entrega"
            />
          </div>
        ))}

        <button
          type="button"
          className=" disabled:text-black/50 pb-12"
          disabled={(!vehicle || !vehicle._id)}
          onClick={() => {
            formik.setFieldValue(`registers.${registers.length}`, { type: '', content: '' })
          }}
        >
          + registro
        </button>
      </div>
    </div>
  );
}
export default FormActivateRenterMotoClub;
